import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressErrorModule } from '@app/common/progress-error';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProgressItemModule } from '@app/common/progress-item';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { NgrxFormsModule } from 'ngrx-forms';
import { SatPopoverModule } from '@zerops/fe/popover';
import { FormsModule } from '@app/common/forms';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';
import { NgrxFormsExtensionsModule } from '@app/common/ngrx-forms-extensions';
import { RealizationDateRejectFormModule } from './modules';
import { TicketRealizationDateContainer } from './ticket-realization-date.container';
import { StoreModule } from '@ngrx/store';
import { ModuleTokens } from './ticket-realization-date.constant';
import { reducer } from './ticket-realization-date.reducer';

@NgModule({
  declarations: [ TicketRealizationDateContainer ],
  imports: [
    CommonModule,
    ProgressItemModule,
    SatPopoverModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    RealizationDateRejectFormModule,
    ProgressErrorModule,
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    ),
    TranslateModule.forChild({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }
    }),
    NgrxFormsModule,
    FormsModule,
    NgrxFormsExtensionsModule
  ],
  exports: [ TicketRealizationDateContainer ]
})
export class TicketRealizationDateModule { }
